<template>
  <div v-loading.fullscreen.lock="loading">
    <custom-dialog class="register-dialog" width="467px" v-if="dialogObj.show" :visible="dialogObj.show">
      <div slot="header" class="header-warp">
        <i class="el-icon-close header-warp-close" @click="close"></i>
        <div class="header-warp-item" :class="{ 'header-warp-item-active': activeId == item.registeredId }"
          v-for="(item, index) in dialogObj.list" @click="changeRegister(item)">挂号单{{ index + 1 }}</div>
      </div>
      <div slot="content">
        <div class="content-tips" v-if="!activeObj.isCurrentDept">请提示用户在小程序支付</div>
        <div class="content-warp">
          <div class="content-warp-item">
            <div class="content-warp-item-label">医生：</div>
            <div class="content-warp-item-value">{{ activeObj.doctorName }} {{ computedDoctorVisit }}</div>
          </div>
          <div class="content-warp-item">
            <div class="content-warp-item-label">号源：</div>
            <div class="content-warp-item-value">
              <div>{{ activeObj.deptName }}</div>
              <div class="column-line"></div>
              <div class="ml8">{{ activeObj.schedulingTime }}</div>
              <div class="column-line"></div>
              <div class="ml8">{{ activeObj.startTimePoint }}-{{ activeObj.endTimePoint }}</div>
              <div class="column-line"></div>
              <div class="ml8">{{ activeObj.registeredCode ? `${activeObj.timeName}${activeObj.registeredCode}号` :
                '签到后排号'
              }}</div>
              <div class="column-line"></div>
              <div class="ml8 colorFE8">待支付</div>
            </div>
          </div>
          <div class="content-warp-item">
            <div class="content-warp-item-label">金额：</div>
            <div class="content-warp-item-value">￥{{ activeObj.price }}</div>
          </div>
          <div class="content-warp-item">
            <div class="content-warp-item-label">实收：</div>
            <div class="content-warp-item-value">￥{{ activeObj.realPay }}</div>
          </div>
          <div class="content-warp-item">
            <div class="content-warp-item-label">创建：</div>
            <div class="content-warp-item-value">{{ activeObj.createBy }}</div>
          </div>
          <div class="content-footer" v-if="activeObj.isCurrentDept">
            <custom-button type="primary" @click="openChargeDialog">收费</custom-button>
            <custom-button @click="refund">退号</custom-button>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
    <custom-dialog width="400px" :showClose="true" title="收费" v-if="chargeDialogShow" :visible="chargeDialogShow"
      @close="chargeDialogClose">
      <div class="charge-warp" slot="content">
        <div class="content-price"><span class="price-icon">¥</span>{{ activeObj.price }}</div>
        <div class="payWay">
          <div @click="activeType = item.value" :class="activeType == item.value ? 'payWay-item active' : 'payWay-item'"
            v-for="item in payWayList" :key="item.value">
            <img :src="item.icon" class="img-icon">
            <div class="item-label">{{ item.label }}</div>
          </div>
        </div>
        <div class="btns">
          <custom-button size="small" type="info" @click="chargeDialogClose">取消</custom-button>
          <custom-button size="small" type="primary" @click="charger">收费</custom-button>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
    <!-- 短信验证弹框 -->
    <SMS-verification ref="SMSDialog" v-if="SMSDialogObj.show" :show="SMSDialogObj.show" @close="SMSDialogClose"
      :dialogObj="SMSDialogObj" @smsVerificationConfirm="smsVerificationConfirm"></SMS-verification>
    <!-- 好码齐扫码 -->
    <howmuch-dialog v-if="howmuchDialogObj.howmuchDialog" :visibleObj="howmuchDialogObj" @close="howmuchDialogClose"
      :dialogObj="howmuchDialogObj" @updateData="howmuchDialogConfirm"></howmuch-dialog>
    <VipCardScan ref="vipCardScan" @scanSuccess="vipCardScanSuccess"></VipCardScan>
  </div>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import { CommonDTO, payDTO } from '@/DTO/index'
import { isNull, debounce, isEmptyArray, timeoutTimer, isNullObj,msgboxWarning,dictText  } from '@/utils/validateBase'
import {  registerCancel } from "@/api/registration"; // 挂号请求
import { getShareCoupon } from '@/api/coupon';
import howmuchDialog from '@/components/howmuchDialog/index'
import VipCardScan from '@/components/VipCard/VipCardScan.vue'
import SMSVerification from '@/components/SMSVerification'
import { doctorVisitList } from '@/utils/const'
import { getVipCardInfo } from "@/api/member"

export default {
  components: {
    CustomDialog,
    howmuchDialog,
    VipCardScan,
    SMSVerification
  },
  props: {
    dialogObj: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      chargeDialogShow: false,
      payWayList: [],
      activeObj: {},
      activeId: '',
      activeType: '',
      loading: false,
      SMSDialogObj: {
        show: false,
      },
      howmuchDialogObj: {
        price: '',
        howmuchDialog: false,

      }
    }
  },
  computed:{
     //处理患者类型
        computedDoctorVisit() {
            return dictText(this.activeObj.doctorVisit, doctorVisitList)
        },
  },
  // 页面初始化
  async created() {
    let PAY_WAY = await CommonDTO.getPayWay()
    this.payWayList = PAY_WAY.filter(item => { return item.value != '1' && item.value != '7' })  //过滤掉医保支付
    this.activeObj = this.dialogObj.list[0]
    this.activeId = this.dialogObj.list[0].registeredId
  },
  methods: {
    close() {
      this.$emit('close')
    },
    chargeDialogClose() {
      this.chargeDialogShow = false
    },
    openChargeDialog() {
      this.chargeDialogShow = true
    },
    refund() {
      msgboxWarning(this, {
        message: "退号后不可恢复，确定退号?",
        confirmFn: async () => {
          let { code } = await registerCancel(this.activeObj.registeredId);
          if (code == 200) {
            this.$message.success("退号成功！");
            this.$emit('close', true)
          }
        },
        cancelFn: () => {
        }
      })
    },
    changeRegister(item) {
      this.activeId = item.registeredId
      this.activeObj = item
    },
    async chargeSuccess(data) {
      let time = await CommonDTO.getSystemTimeDTO()
      let obj = { orderPayNumber: data.orderPayNumber, paySuccess: '1', amount: this.activeObj.price, payTime: this.$moment(time).format('YYYY-MM-DD HH:mm:ss') }
      payDTO.payCallback(obj).then(async result => {
        if (result.code == 200) {
          this.SMSDialogObj.show = false
          await getShareCoupon({ orderId: this.activeObj.registeredId, type: 1 }).then((res => {
            if ((res.code == 200) && !isNull(res.data) && !isEmptyArray(res.data)) {
              this.$message.success("恭喜获得优惠券！");
            } else {
              this.$message.success("收费成功！");
            }
          }))
          this.$emit('close', true)
          this.chargeDialogShow = false
          this.loading = false
        } else {
          this.loading = false
          this.$refs.SMSDialog.loading = false
        }
      })
    },
    charger: debounce(async function () {
      this.loading = true
      let payWay = this.activeType
      let ctOrderIds = []
      ctOrderIds[0] = this.activeObj.ctOrderId
      let preParams = {
        amount: this.activeObj.price,
        ctOrderIds: ctOrderIds,
        payWay: this.activeType,
        deptId: this.$session.get('deptId'),
      }
      if (payWay == 3) {
        // 好码齐支付
        this.howmuchDialogObj.price = this.activeObj.price
        this.howmuchDialogObj.howmuchDialog = true
        this.loading = false
      } else if (payWay == 8) {
        this.loading = false
        this.SMSDialogObj.show = true
        this.SMSDialogObj.price = this.activeObj.price
        this.SMSDialogObj.phone = this.activeObj.phone
        this.$nextTick(async () => {
          let curAmount = await this.$refs.SMSDialog.getWalletAmount(this.activeObj.phone)
          if (curAmount < this.activeObj.price) {
            this.$message.error('会员钱包余额不足，请充值后继续操作')
          }
        })
      } else if (payWay == 12) {
        this.$refs['vipCardScan'].open()
        this.loading = false
      }  else {
        payDTO.payFun(preParams).then(async res => {
          let { code, data } = res
          if (code == 200) {
            this.chargeSuccess(data)
          } else {
            this.loading = false
            this.$refs.SMSDialog.loading = false
          }
        }).catch(err => {
          this.loading = false
        })
      }
    }, 500, true),
    async vipCardScanSuccess (code) {
      if (code) {
        const res = await getVipCardInfo({ vipCardNumber: code })
        if (res.code === 200) {
          if ([2, 3, 4].includes(res.data.status)) {
            let text = ''
            switch (res.data.status) {
              case 2:
                text = '该至尊卡已过期，暂不可用!'
                break
              case 3:
                text = '该至尊卡已被冻结，暂不可用!'
                break
              case 4:
                text = '该至尊卡未激活，暂不可用!'
                break
            }
            this.$confirm(text, '提示', {
              showConfirmButton: false,
              cancelButtonText: '关闭',
              type: 'warning'
            }).then(() => {}).catch(() => {})
            return
          }
          const balance = res.data.balance || 0
          if (balance < this.dialogObj.price) {
            this.$confirm(`余额不足，剩余金额${balance}`, '提示', {
              showConfirmButton: false,
              cancelButtonText: '关闭',
              type: 'warning'
            }).then(() => {}).catch(() => {})
            return
          }

          let ctOrderIds = []
          ctOrderIds[0] = this.activeObj.ctOrderId
          let preParams = {
            amount: this.activeObj.price,
            ctOrderIds: ctOrderIds,
            payWay: 12,
            deptId: this.$session.get('deptId'),
            attach: {
              vipCardNumber: res.data.vipCardNumber
            }
          }

          payDTO.payFun(preParams).then(async res2 => {
            let { code, data } = res2
            if (code == 200) {
              this.chargeSuccess(data)
            } else {
              this.loading = false
              this.$refs.SMSDialog.loading = false
            }
          })
        }
      }
    },
    //短信验证确定
    smsVerificationConfirm(obj) {
      let { phone, price, code, curAmount } = obj
      if (curAmount < price) {
        this.$message.error('会员钱包余额不足，请充值后继续操作')
        return
      }
      this.$refs.SMSDialog.loading = true
      let ctOrderIds = []
      ctOrderIds[0] = this.activeObj.ctOrderId
      let preParams = {
        ctOrderIds,
        amount: price,
        payWay: '8',
        attach: { phone, smsCode: code }
      }
      payDTO.payFun(preParams).then(async res => {
        let { code, data } = res
        if (code == 200) {
          this.chargeSuccess(data)
        } else {
          this.loading = false
          this.$refs.SMSDialog.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$refs.SMSDialog.loading = false
      })
    },
    howmuchDialogClose() {
      this.howmuchDialogObj.howmuchDialog = false
    },
    howmuchDialogConfirm(obj) {
      this.loading = true
      let ctOrderIds = []
      ctOrderIds[0] = this.activeObj.ctOrderId
      let { payWay, userAuthCode, price } = obj;
      let preParams = {
        ctOrderIds,
        amount: price,
        payWay,
        attach: { userAuthCode }
      }
      payDTO.payFun(preParams).then(async res => {
        let { code, data } = res
        if (code == 200) {
          this.getConsumeMessage(data.attach.queueId)
        } else {
          this.loading = false
          this.howmuchDialogObj.howmuchDialog = false
        }
      }).catch(err => {
        this.loading = false
      })
    },
    getConsumeMessage(id) {
      this.handleConsumeMessage(id)
      timeoutTimer('timeoutId2', () => {
        this.closeInterval()
      }, 5 * 60 * 1000)
    },
    handleConsumeMessage(id) {
      CommonDTO.consumeMessage({ id }).then(async res => {
        if (res.code == 200) {
          let list = isNull(res.data) ? [] : res.data
          let defeatedObj = list.find(item => { return item.type == 1 && item.status == '2' }) //失敗消息
          let isEnd = list.some(item => { return item.type == -1 })
          if (!isNullObj(defeatedObj)) {
            this.$message.error(defeatedObj.text)
            this.closeInterval()
            return;
          }
          if (isEnd) {
            await getShareCoupon({ orderId: this.activeObj.registeredId, type: 1 }).then((res => {
              if ((res.code == 200) && !isNull(res.data) && !isEmptyArray(res.data)) {
                this.$message.success("恭喜获得优惠券！");
              } else {
                this.$message.success("收费成功！");
              }
            }))
            this.closeInterval()
            return;
          }
          timeoutTimer('timeoutId1', () => {
            this.handleConsumeMessage(id)
          }, 1000)
        } else {
          this.closeInterval()
        }
      }).catch(err => {
        this.$message.error('支付超时')
        this.closeInterval()
      })

    },
    closeInterval() {
      clearTimeout(this.timeoutId1)
      clearTimeout(this.timeoutId2)
      this.chargeDialogShow = false
      this.howmuchDialogObj.howmuchDialog = false
      this.loading = false
      this.$emit('close', true)
    },
    SMSDialogClose() {
      this.SMSDialogObj.show = false
    },
  }
}
</script>

<style lang="less" scoped>
.header-warp {
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 24px;
  border-bottom: 1px solid #EBEAEE;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;

  .header-warp-close {
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
  }

  .header-warp-item {
    font-weight: 400;
    font-size: 16px;
    color: #667182;
  }

  .header-warp-item-active {
    position: relative;
    font-weight: 500;
    color: #000000;

    &::before {
      content: '';
      position: absolute;
      bottom: -18px;
      width: 58px;
      height: 3px;
      background: #1890FF;
      border-radius: 4px 4px 4px 4px;
    }
  }
}

.register-dialog /deep/.dialog-content {
  padding: 0 !important;

  .content-tips {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #FFFBE8;
    font-weight: 400;
    font-size: 14px;
    color: #FE8F1F;
  }

  .content-warp {
    padding: 24px;
  }

  .column-line {
    width: 1px;
    height: 14px;
    background: #E0E0E0;
    margin-left: 6px;
  }

  .content-warp-item {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    margin-bottom: 8px;

    .content-warp-item-label {
      flex-grow: 0;
    }

    .content-warp-item-value {
      display: flex;
      align-items: center;
    }
  }

  .content-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
  }
}

.charge-warp {

  .content-price {
    color: #FE8F1F;
    font-size: 24px;
    font-weight: bold;
    text-align: center;

    .price-icon {
      font-size: 16px;
      margin-right: 4px;
    }
  }

  .payWay {
    margin-top: 24px;
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-gap: 8px;

    .payWay-item {
      width: 112px;
      height: 40px;
      background: #FFFFFF;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #D3D3D5;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1F2329;
      font-size: 14px;
      box-sizing: border-box;
      cursor: pointer;

      &:hover {
        border: 1px solid #1890FF;
      }

      .img-icon {
        width: 16px;
        height: 16px;
        flex-grow: 0;
        flex-shrink: 0;
        margin-right: 6px;
      }

      .item-label {
        width: 56px;
        text-align: justify;
        text-align-last: justify;
      }
    }

    .active {
      border: 1px solid #1890FF;
      background: #E8F4FF;
      color: #1890FF;
    }
  }
}

.btns {
  margin-top: 28px;
  display: flex;
  justify-content: flex-end;
  padding: 0 24px;
  padding-bottom: 16px;
}
</style>